/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_PresentInputs */

const en_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Present`)
};

const fr_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier présent`)
};

const de_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei vorhanden`)
};

const it_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File presente`)
};

const ru_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл присутствует`)
};

const es_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo presente`)
};

const zh_cn2_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件存在`)
};

const ja_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルあり`)
};

const hi_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल मौजूद है`)
};

const pt_pt2_file_present = /** @type {(inputs: File_PresentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentar Arquivo`)
};

/**
* | output |
* | --- |
* | "File Present" |
*
* @param {File_PresentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_present = /** @type {((inputs?: File_PresentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_PresentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_present(inputs)
	if (locale === "de") return de_file_present(inputs)
	if (locale === "it") return it_file_present(inputs)
	if (locale === "ru") return ru_file_present(inputs)
	if (locale === "es") return es_file_present(inputs)
	if (locale === "zh-CN") return zh_cn2_file_present(inputs)
	if (locale === "ja") return ja_file_present(inputs)
	if (locale === "hi") return hi_file_present(inputs)
	if (locale === "pt-PT") return pt_pt2_file_present(inputs)
	return en_file_present(inputs)
});